// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"32b8f3da","150":"e2cdf113","224":"90803a71","292":"19c876bf","382":"cae26eb3","443":"6e90f0dd","487":"5a119341","499":"ffde6343","543":"9e4afd24","730":"34fe3124","766":"0a3f1495","830":"8de53d50","863":"9355c27d","937":"09e77ecc","968":"7eff25d2","985":"565e88cd"}[chunkId] + ".chunk.js";
};